// noinspection JSAnnotator
export default require("./fs-tpp-api.js");
// wrapper so the api could be transpiled with babel, but kept in the old form for compatibility